exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".signature[data-v-3284ddfb]{height:90%;width:90%}", ""]);

// exports
